<template>
    <div></div>
</template>

<script>
import url from "../../service/base-url.js";
import { storage } from "../../service/storage.js";
export default {
  mounted() {
    if (this.$route.query.action == "") {
      let currentUrl = storage.get("currentUrl");
      if (!currentUrl) currentUrl = "/";
      parent.location.href = currentUrl;
    } else if (this.$route.query.action == "create") {
      parent.location.href = `${window.location.origin}/createFishery`;
      // parent.location.href =
      //   url.baseUrl + "/Company/Register?rurl=" + parent.location.origin;
    }
  }
};
</script>

<style>
</style>
